// extracted by mini-css-extract-plugin
export default {"credit":"FooterContainer_credit__ISCjt","creditLink":"FooterContainer_creditLink__5zgqm"};